import { useAppSelector } from 'app/hooks'
import CommonLinkButton from 'components/Button/CommonLinkButton'
import { LicenseType } from 'features/licenses/types'
import { selectYouAreDistributor } from 'features/rootDomains/selectors'
import { LicenseRowActionsWrapper } from './styles'

interface LicenseRowActionsProps {
  license: LicenseType
  rootDomainId: string | null
  onClickToReclaim: VoidFunction
  onClickToTransfer: VoidFunction
}

function LicenseRowActions({
  license,
  rootDomainId,
  onClickToReclaim,
  onClickToTransfer,
}: LicenseRowActionsProps) {
  const notRma = license.enabled !== false
  const youAreDistributor = useAppSelector(selectYouAreDistributor)

  const canReclaim =
    youAreDistributor &&
    notRma &&
    license.domainId !== rootDomainId &&
    license.purchaserDomainId === rootDomainId
  const canTransfer =
    youAreDistributor &&
    notRma &&
    (license.domainId === rootDomainId || !license.domainId) &&
    license.purchaserDomainId === rootDomainId

  if (canReclaim || canTransfer) {
    return (
      <LicenseRowActionsWrapper>
        {canReclaim && (
          <CommonLinkButton onClick={onClickToReclaim}>
            Reclaim
          </CommonLinkButton>
        )}
        {canTransfer && (
          <CommonLinkButton onClick={onClickToTransfer}>
            Transfer
          </CommonLinkButton>
        )}
      </LicenseRowActionsWrapper>
    )
  }
  return null
}

export default LicenseRowActions
